import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { calculateDiscountAmount } from "../library/utils";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";
import { elsevierStyleSheetJSfileImport } from "../library/utils";

const Book = (props) => {
  const [quantity, setQuantity] = useState("");
  const [addedToCart, setAddedToCart] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    elsevierStyleSheetJSfileImport();
  }, []);

  const pushToShoppingCart = (event) => {
    event.preventDefault();
    navigate("/shoppingCart");
  };

  const handleChange = (event) => {
    event.preventDefault();
    setQuantity(event.target.value);
  };

  const addToCart = async (event) => {
    event.preventDefault();
    const emailId = window.sessionStorage.getItem("emailId");
    const product_id = props.bookDetails.product_id;
    const total_price = props.bookDetails.list_price;
    const discount_price = calculateDiscountAmount(
      total_price,
      props.bookDetails.discount_percentage
    );
    const subtotal = quantity * (total_price - discount_price);
    const discount_category = props.bookDetails.discount_category;
    setButtonDisabled(true);
    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({
      useremailaddress: emailId,
      product_id: product_id,
      quantity: quantity,
      subtotal: subtotal,
      discount_price: discount_price,
      discount_category: discount_category,
      total_price: total_price,
    });

    const config = {
      method: "post",
      url: `${backendBookartUrl}/insert_cart_details?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      const response = await axios(config);
      props.checkAndUpdatedCart(true);
      setAddedToCart(response.data.product_added);
      setButtonDisabled(false);
      // props.checkAndUpdatedCart(false);
    } catch (error) {
      setButtonDisabled(false);
      console.log(error);
    }
  };

  useEffect(() =>{
    props.checkAndUpdatedCart(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[buttonDisabled]);

  return (
    <React.Fragment>
      <div className="book-info">
        <div className="row book-mobile">
          <div className="col-md-2 col-sm-2 col-lg-2 width-100">
            {props.bookDetails.book_cover !== null ? (
              <img
                src={`data:image/jpeg;base64,${props.bookDetails.book_cover}`}
                className="book-cover-image"
                alt=""
              />
            ) : (
              <img
                className="book-cover-image"
                src="ElsevierStyleSheet/images/ElsevierImage.png"
                alt=""
              />
            )}
          </div>
          <div className="col-md-7">
            <p>{props.bookDetails.title}</p>
            <div className="font-14 margin-5">
              <b>Published: </b> {props.bookDetails.year}
            </div>
            <div className="font-14 margin-5">
              <b>Author: </b>
              {props.bookDetails.author}
            </div>
            <div className="font-14 margin-5">
              <b>ISBN: </b>
              {props.bookDetails.product_id}
            </div>
            <div className="font-14 margin-5">
              <label className="font-12">
                {props.bookDetails.publication_details}
              </label>
            </div>
          </div>
          <div className="none-mobile"></div>
          <div className="col-md-3 text-end">
            <form onSubmit={addToCart}>
              {props.bookDetails.ListPrice === 0 ? (
                <div style={{ display: "flex" }}>
                  <p>₹ {props.bookDetails.list_price}</p>
                  <div style={{ fontSize: "14px", marginLeft: "0.5vw" }}>
                    {"- To Be Announced"}
                  </div>
                </div>
              ) : (
                <p>₹ {props.bookDetails.list_price}</p>
              )}
              <div className="font-14 discount-tag">
                Discount&nbsp;{props.bookDetails.discount_category}&nbsp;
                <button type="button"
                  aria-controls={"discount-" + props.bookDetails.product_id}
                  className="es-link colored es-js-popup"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 104 128"
                      className="info-icon"
                    >
                      <path
                        fill="#007398"
                        d="M52 12c-13.624 0-26.431 5.306-36.063 14.937C6.304 36.571 1 49.378 1 63c0 28.122 22.878 51 51 51h.008c13.62 0 26.427-5.306 36.059-14.937C97.697 89.429 103 76.622 103 63c0-28.122-22.878-51-51-51zm29.27 80.268c-7.815 7.817-18.208 12.12-29.262 12.12H52c-22.822 0-41.39-18.566-41.39-41.388 0-11.056 4.305-21.45 12.12-29.268C30.55 25.915 40.944 21.61 52 21.61c22.822 0 41.39 18.57 41.39 41.391 0 11.056-4.305 21.449-12.12 29.268zM47 38h10v10H47zm0 16h10v34H47z"
                      />
                    </svg>
                  </button>
                </div>
                <div
                  aria-labelledby={"discount-" + props.bookDetails.product_id}
                  className="info-popup es-popup below auto"
                  hidden="hidden"
                  id={"discount-" + props.bookDetails.product_id}
                  role="dialog"
                >
                  <div className="es-popup-content info-popup-content">
                    <table>
                      <tbody className="font-12 text-start">
                        <tr>
                          <td className="width-80">Actual Price</td>
                          <td>₹ {props.bookDetails.list_price}</td>
                        </tr>
                        <tr>
                          <td>
                            Discount&nbsp;
                            {props.bookDetails.discount_category}{" "}
                            <label>
                              {props.bookDetails.discount_percentage}% Off
                            </label>
                          </td>
                          <td>
                            - ₹{" "}
                            {calculateDiscountAmount(
                              props.bookDetails.list_price,
                              props.bookDetails.discount_percentage
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Total Price</td>
                          <td>
                            ₹{" "}
                            {(
                              props.bookDetails.list_price -
                              calculateDiscountAmount(
                                props.bookDetails.list_price,
                                props.bookDetails.discount_percentage
                              )
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
  
                <div className="font-14">
                  Qty&nbsp;
                  <input
                    type="number"
                    min="1"
                    max="99999"
                    name="quantity"
                    value={quantity}
                    placeholder="&nbsp;"
                    onChange={handleChange}
                    required
                    className="qtyTextbox"
                  />
                </div>
                {addedToCart ? (
                  <button
                    className="es-button secondary cart-button"
                    type="button"
                    onClick={pushToShoppingCart}
                  >
                    <span>View Cart</span>
                    <svg
                      focusable="false"
                      height="24"
                      viewBox="0 0 54 128"
                      width="11"
                    >
                      <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                    </svg>
                  </button>
                ) : (
                  <button
                    className="es-button primary cart-button"
                    disabled={buttonDisabled}
                    type="submit"
                  >
                    Add to cart +
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  
  export default Book;